import React from "react";

import translations, { Translations } from "./translations";

export type LocaleProviderProps = {
  locale: string;
  children?: React.ReactNode;
};

export interface LocaleContextProps {
  locale: string;
  translation: Translations;
}

const LocaleContext = React.createContext<LocaleContextProps>({
  locale: "de_de",
  translation: translations.de_DE,
});

export const LocaleProvider: React.FC<LocaleProviderProps> = (
  props: LocaleProviderProps
): React.JSX.Element => {
  let translation = translations.de_DE;
  if (props.locale == "en_us") {
    translation = translations.en_US;
  } else if (props.locale == "pl_pl") {
    translation = translations.pl_PL;
  }

  return (
    <LocaleContext.Provider
      value={{
        locale: props.locale,
        translation,
      }}
    >
      {props.children}
    </LocaleContext.Provider>
  );
};

export const LocaleConsumer = LocaleContext.Consumer;

export default LocaleContext;
